export const selectCustomer = state => state.customer.data;
export const selectCustomerStatus = state => state.customer.status;
export const selectSubscriptionPreferences = state => state.customer.subscriptionPreferences;
export const selectId = state => state.customer.data?.id;
export const selectUsername = state => state.customer.data?.username;
export const selectBillingFirstname = state => state.customer.data?.billing_firstname;
export const selectBillingLastname = state => state.customer.data?.billing_lastname;
